import request from '@/axios'
import type {
  MessageActionType,
  QueryMessage,
  MessageListResp,
  MessageInfo,
  SendMessageType
} from './types'

export const getMessageCountApi = (data?: QueryMessage): Promise<IResponse<MessageListResp>> => {
  return request.get<MessageListResp>({ url: '/v1/message/count', params: data })
}

// name code page count
export const getMessageListApi = (data?: QueryMessage): Promise<IResponse<MessageListResp>> => {
  return request.get<MessageListResp>({ url: '/v1/message', params: data })
}

export const messageActionApi = (data?: MessageActionType): Promise<IResponse<MessageListResp>> => {
  return request.get<MessageListResp>({ url: '/v1/message/action', params: data })
}

export const sendMessageApi = (data?: SendMessageType): Promise<IResponse<MessageListResp>> => {
  return request.post<MessageListResp>({ url: '/v1/message/create', data })
}

export const getAccessMessageApi = (data?: QueryMessage): Promise<IResponse<MessageListResp>> => {
  return request.get<MessageListResp>({ url: '/v1/message/useraccess', params: data })
}
